var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_4",
    "data-name": "Grupo 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.529,
    height: 112.031,
    viewBox: "0 0 109.529 112.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M43.828,70.5H28.711A3.214,3.214,0,0,0,25.5,73.716V87.573a3.214,3.214,0,0,0,3.211,3.21H43.828a3.214,3.214,0,0,0,3.211-3.21V73.716A3.214,3.214,0,0,0,43.828,70.5M40.618,84.363h-8.7V76.924h8.7Z",
    transform: "translate(-3.551 -19.119)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M92.948,77.323H65.231a3.64,3.64,0,0,0,0,7.281H92.948a3.64,3.64,0,0,0,0-7.281",
    transform: "translate(-8.578 -20.068)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M43.828,102.706H28.711a3.214,3.214,0,0,0-3.211,3.211v13.858a3.214,3.214,0,0,0,3.211,3.211H43.828a3.214,3.214,0,0,0,3.211-3.211V105.917a3.215,3.215,0,0,0-3.211-3.211m-3.211,13.859h-8.7v-7.438h8.7Z",
    transform: "translate(-3.551 -23.603)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M92.948,109.525H65.231a3.64,3.64,0,0,0,0,7.281H92.948a3.64,3.64,0,0,0,0-7.281",
    transform: "translate(-8.578 -24.553)",
    fill: "#314164"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M29.143,10.8A13.891,13.891,0,0,0,15.268,24.679v.231H14.5A14.52,14.52,0,0,0,0,39.415V108.33a14.521,14.521,0,0,0,14.5,14.5H95.025a14.521,14.521,0,0,0,14.5-14.5V39.415a14.52,14.52,0,0,0-14.5-14.5h-.763V24.68a13.875,13.875,0,0,0-27.751,0v.231H43.02V24.68A13.894,13.894,0,0,0,29.143,10.8ZM24.269,24.679a4.873,4.873,0,0,1,9.745,0v7.374H24.268Zm70.756,89.152H14.5a5.507,5.507,0,0,1-5.5-5.5V58.822h91.523V108.33a5.508,5.508,0,0,1-5.5,5.5ZM75.514,24.679a4.873,4.873,0,0,1,9.745,0v7.374H75.513V24.679Zm-9,9.234v2.642a4.5,4.5,0,0,0,4.5,4.5H89.762a4.5,4.5,0,0,0,4.5-4.5V33.913h.763a5.507,5.507,0,0,1,5.5,5.5V49.821H9V39.414a5.507,5.507,0,0,1,5.5-5.5h.763v2.642a4.5,4.5,0,0,0,4.5,4.5H38.518a4.5,4.5,0,0,0,4.5-4.5V33.913Z",
    transform: "translate(0 -10.804)",
    fill: "#314164"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.1e443f0238721dab81a7af317e6dedaa.svg";
export { ForwardRef as ReactComponent };